export const fr = {
  whatToConsult: `Que souhaitez-vous consulter?`
};
